import Macy from 'macy';

export default () => {
  if( !window.macyGrid ){
    $(window).on('load', () => {
      const grid = Macy({
        container: '.posts-listing--alt',
        columns: 3,
        trueOrder: true,
        margin: {
          x: 30,
          y: 34,
        },
        breakAt: {
          1160: {
            columns: 2,
          },
          767: {
            columns: 1,
            margin: {
              x: 0,
              y: 25,
            },
          },
        },
      });

      grid.on(grid.constants.EVENT_IMAGE_COMPLETE, function(ctx) {
        $(ctx.instance.container).addClass('posts-listing--grid');
        window.macyGrid.resizer();
      });

      window.macyGrid = grid;
    });
  }
};



// WEBPACK FOOTER //
// ./scripts/layout/news-listing.js